export default {
    edit: 'Modifica',
    location: 'Località + T&C',
    filter: 'Filtro',
};
